import type { ComponentType } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type {
  SurveysEnumsRespondentStrategyEnum,
  SurveysRespondentStrategyInput,
} from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { EmployeesStrategy } from 'modules/engagement_surveys/components/SurveyWizard/steps/ParticipantsStep/strategies/Employees'
import { LegalEntitiesStrategy } from 'modules/engagement_surveys/components/SurveyWizard/steps/ParticipantsStep/strategies/LegalEntities'
import { LocationsStrategy } from 'modules/engagement_surveys/components/SurveyWizard/steps/ParticipantsStep/strategies/Locations'
import { TeamsStrategy } from 'modules/engagement_surveys/components/SurveyWizard/steps/ParticipantsStep/strategies/Teams'

const strategyComponentMap: Record<
  SurveysEnumsRespondentStrategyEnum,
  | ComponentType<{ strategy: SurveysRespondentStrategyInput; onChange: (ids: number[]) => void }>
  | undefined
> = {
  employees: EmployeesStrategy,
  legal_entities: LegalEntitiesStrategy,
  locations: LocationsStrategy,
  teams: TeamsStrategy,
  all_employees: undefined,
  everyone: undefined,
  managers: undefined,
}

interface ParticipantsSelectorProps {
  value: SurveysRespondentStrategyInput
  onChange: (respondentStrategy: SurveysRespondentStrategyInput) => void
}

export function ParticipantsSelector({ value, onChange }: ParticipantsSelectorProps) {
  const StrategyComponent = strategyComponentMap[value.strategy]

  return (
    <Box gap="s16">
      <SelectField
        label={i18n.t('surveys.configuration.participants.label')}
        value={value.strategy}
        onChange={(strategy) => {
          onChange({
            // @ts-expect-error: Gamma select is not typed and we can't use assertions
            strategy,
            arguments: [],
          })
        }}
        options={[
          {
            label: i18n.t('surveys.configuration.participants.options.everyone.label'),
            value: 'everyone',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.all_employees.label'),
            value: 'all_employees',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.employees.label'),
            value: 'employees',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.managers.label'),
            value: 'managers',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.teams.label'),
            value: 'teams',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.locations.label'),
            value: 'locations',
          },
          {
            label: i18n.t('surveys.configuration.participants.options.legal_entities.label'),
            value: 'legal_entities',
          },
        ]}
      />

      {StrategyComponent && (
        <StrategyComponent
          strategy={value}
          onChange={(ids) => {
            onChange({
              ...value,
              arguments: ids,
            })
          }}
        />
      )}
    </Box>
  )
}
